export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const FETCH_USER = 'FETCH_USER'